import React, { useState } from "react";
import axios from "axios";

function ContactUs() {
    const [formData, setFormData] = useState({
        name: "",
        mobile: "",
        email: "",
    });
    
    const [errors, setErrors] = useState({});
    const [snackbar, setSnackbar] = useState({ message: "", type: "", open: false });
    
    const staticData = {
        subject: "enquiry",
        message: "I am interested in your properties. Please contact me.",
        toEmail: "n.kotesh18@gmail.com",
        heading: "mrindiahosingltd"
    };

    const validateForm = () => {
        let newErrors = {};

        if (!formData.name.trim()) newErrors.name = "Name is required";
        if (!formData.mobile.trim()) {
            newErrors.mobile = "Mobile number is required";
        } else if (!/^[6-9]\d{9}$/.test(formData.mobile)) {
            newErrors.mobile = "Enter a valid 10-digit mobile number";
        }

        if (!formData.email.trim()) {
            newErrors.email = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = "Enter a valid email address";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });

        if (errors[e.target.name]) {
            setErrors((prevErrors) => ({ ...prevErrors, [e.target.name]: "" }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        const finalData = { ...formData, ...staticData };
        const formDataToSend = new FormData();
        for (let key in finalData) {
            formDataToSend.append(key, finalData[key]);
        }

        try {
            await axios.post("https://api.smartaihr.com/api/users/sendingEmail", formDataToSend, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            setSnackbar({ message: "Form submitted successfully!", type: "success", open: true });
            setFormData({ name: "", mobile: "", email: "" });
        } catch (error) {
            setSnackbar({ message: "Failed to submit the form. Please try again.", type: "error", open: true });
        }
    };

    return (
        <div>
            <form onSubmit={handleSubmit}>
                <div className="mb-[30px]">
                    <label className="text-[16px] font-bold">NAME</label>
                    <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className="p-4 mt-[5px] bg-[#99CBED] rounded-[10px] w-full md:h-[54px] h-[44px] outline-none"
                    />
                    {errors.name && <p className="text-red-500">{errors.name}</p>}
                </div>
                <div className="mb-[30px]">
                    <label className="text-[16px] font-bold">MOBILE NUMBER</label>
                    <input
                        type="text"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleChange}
                        className="p-4 mt-[5px] bg-[#99CBED] rounded-[10px] w-full md:h-[54px] h-[44px] outline-none"
                    />
                    {errors.mobile && <p className="text-red-500">{errors.mobile}</p>}
                </div>
                <div className="mb-[30px]">
                    <label className="text-[16px] font-bold">EMAIL</label>
                    <input
                        type="text"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className="p-4 mt-[5px] bg-[#99CBED] rounded-[10px] w-full md:h-[54px] h-[44px] outline-none"
                    />
                    {errors.email && <p className="text-red-500">{errors.email}</p>}
                </div>
                <button
                    type="submit"
                    className="md:text-[18px] text-[16px] font-bold border-[3px] border-[#3498DB] rounded-[16px] px-[50px] py-[12px]"
                >
                    Submit
                </button>
            </form>

            {/* Snackbar */}
            {snackbar.open && (
                <div
                    className={`fixed top-4 right-0 transform -translate-x-1/2 px-6 py-3 text-white rounded-lg ${
                        snackbar.type === "success" ? "bg-green-500" : "bg-red-500"
                    }`}
                >
                    {snackbar.message}
                    <button
                        className="ml-4 text-white font-bold"
                        onClick={() => setSnackbar({ ...snackbar, open: false })}
                    >
                        ✖
                    </button>
                </div>
            )}
        </div>
    );
}

export default ContactUs;
